import { makeActionCreator } from '../../utils';
import { httpActionTypes } from '../actionTypes';

// HTTP ACTION CREATORS

/*+++++++++++++++++++++++++++
 /+ FACEBOOK API
 +++++++++++++++++++++++++++*/

/**
 * Create an action creator that sets the state value of Facebook Login API request made
 * @constant
 * @type {function} facebookRequestMade action creator
 */
export const facebookRequestMade = makeActionCreator(httpActionTypes.FACEBOOK_REQUEST_MADE, 'request');

/**
 * Create an action creator that sets the state value of Facebook Login API request success
 * @constant
 * @type {function} facebookRequestSuccess action creator
 */
export const facebookRequestSuccess = makeActionCreator(httpActionTypes.FACEBOOK_REQUEST_SUCCESS, 'request');

/**
 * Create an action creator that sets the state value of Facebook Login API request error
 * @constant
 * @type {function} facebookRequestError action creator
 */
export const facebookRequestError = makeActionCreator(httpActionTypes.FACEBOOK_REQUEST_ERROR, 'request', 'error');


/*+++++++++++++++++++++++++++
 /+ IAM API
 +++++++++++++++++++++++++++*/

/**
 * Create an action creator that sets the state value of IAM API request made
 * @constant
 * @type {function} iamRequestMade action creator
 */
export const iamRequestMade = makeActionCreator(httpActionTypes.IAM_REQUEST_MADE, 'request');

/**
 * Create an action creator that sets the state value of IAM API request success
 * @constant
 * @type {function} iamRequestSuccess action creator
 */
export const iamRequestSuccess = makeActionCreator(httpActionTypes.IAM_REQUEST_SUCCESS, 'request');

/**
 * Create an action creator that sets the state value of IAM API request error
 * @constant
 * @type {function} iamRequestError action creator
 */
export const iamRequestError = makeActionCreator(httpActionTypes.IAM_REQUEST_ERROR, 'request', 'error');


// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/actions/actionCreators/httpActionCreators.js